import React, {useState, useRef, useEffect} from 'react'
import "./DaySlider.css";


const DaySlider = ({ dayTitle, text, images }) => {


  const slideRefs = useRef([]);
  const [height, setHeight] = useState("auto");


  const slides = [
    { type: "text", content: text },
    ...images.map((img) => ({ type: "image", content: img })),
  ];

  const [index, setIndex] = useState(0);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const handleNext = () => {
    if (index < slides.length - 1) setIndex(index + 1);
  };

  const handlePrev = () => {
    if (index > 0) setIndex(index - 1);
  };

  const onTouchStart = (e) => {
    touchStartX.current = e.targetTouches[0].clientX;
  };

  const onTouchMove = (e) => {
    touchEndX.current = e.targetTouches[0].clientX;
  };

  const onTouchEnd = () => {
    const diff = touchStartX.current - touchEndX.current;
    if (diff > 50) handleNext();
    if (diff < -50) handlePrev();
  };

  const showNav = slides.length > 1 && images.length > 0;



  useEffect(() => {
  const el = slideRefs.current[index];
  if (el) {
    setHeight(el.offsetHeight);
  }
}, [index]);



  return (
    <div className="day-wise">
        
      <p className="iti-head">{dayTitle}</p>

        {showNav && ( 
            <div className="nav-buttons">
            <button className='left' onClick={handlePrev} disabled={index === 0}>‹</button>
            <button className='right' onClick={handleNext} disabled={index === slides.length - 1}>›</button>
            </div>
        )}



      <div
        className="slider-wrapper"
        style={{ height }}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        <div
          className="slider-track"
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {slides.map((slide, i) => (
          
            <div className="slide" 
                key={i}
                ref={(el) => (slideRefs.current[i] = el)}
                >
                {slide.type === "text" ? (
                
                <div className="text-slide">
                  {slide.content}
                </div>
              ) : (
                <div className="image-slide">
                  <img src={slide.content} alt={`slide-${i}`} />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Optional arrows */}
    

    </div>
  );
};

export default DaySlider;